import React from 'react';

import PropTypes from 'prop-types';

import styles from './DevExpandableBlock.module.scss';

/**
 * This component is a simple block with a header and a content that can be expandable.
 */
const DevExpandableBlock = ({ expanded = false, header = null, children = null }) => {
    const [open, setOpen] = React.useState(expanded);

    React.useEffect(
        () => {
            setOpen(expanded);
        },
        [expanded],
    );

    if (!header && !children) {
        return null;
    }

    return (
        <div className={styles.expandable_block}>
            <div
                className={styles.header}
                onClick={() => {
                    setOpen((prevState) => !prevState);
                }}
            >
                <div className={styles.left}>
                    {header}
                </div>
                <div className={styles.right}>
                    {open
                        ? <>&darr;</>
                        : <>&rarr;</>
                    }
                </div>
            </div>
            {children && open && (
                <div className={styles.content}>
                    {children}
                </div>
            )}
        </div>
    );
};

DevExpandableBlock.propTypes = {
    /**
     * Whether the block should be expanded.
     */
    expanded: PropTypes.bool,
    /**
     * The title or the header of the block.
     */
    header: PropTypes.any,
    /**
     * The content of the block when it is expanded.
     */
    children: PropTypes.any,
};

export default DevExpandableBlock;
